import React from 'react';
import { Box, Typography } from '@mui/material';

import { CandidatesWithPosition } from '@types';
import { RecommendedStar } from 'components/common/RecommendedStar/RecommendedStar';

import { RegionTag } from './RegionTag';

export const CandidateNameCell: React.FC<{
  candidate: CandidatesWithPosition;
  positionName?: string;
  withRegion?: boolean;
}> = ({ candidate, positionName, withRegion = true }) => (
  <Box
    display="grid"
    gridTemplateColumns={withRegion ? 'auto minmax(0, 1fr)' : 'minmax(0, 1fr)'}
    alignItems="center"
    columnGap={1}
    rowGap={0.25}
  >
    {withRegion && <RegionTag country={candidate.country} />}
    <Box display="flex" alignItems="center" gap={1} minWidth={0}>
      <Typography variant="body1" color="text.primary" noWrap>
        {`${candidate.firstName} ${candidate.lastName}`}
      </Typography>
      {Boolean(candidate.seniority) && (
        <Typography
          variant="body2"
          color="text.secondary"
          noWrap
          flexShrink={0}
        >
          {candidate.seniority}
        </Typography>
      )}
      {Boolean(candidate.isStarred) && <RecommendedStar />}
    </Box>
    {Boolean(positionName) && (
      <Typography variant="body2" color="text.secondary" gridColumn={-2} noWrap>
        {positionName}
      </Typography>
    )}
  </Box>
);
